import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description QnA icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { QnA } from '@sravni/design-system-icons'
 *
 * <QnA />
 * ```
 */
var QnA = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "QnA", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.143 15H3.57c-.79 0-1.428-.64-1.428-1.428v-10c0-.79.639-1.429 1.428-1.429h12.857c.79 0 1.429.64 1.429 1.429v10c0 .789-.64 1.428-1.429 1.428h-4.285M12.202 15l-.06 2.857-5-2.857", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 10v-.23c0-.754.54-1.163 1.083-1.477.529-.308 1.06-.708 1.06-1.447 0-1.02-.96-1.846-2.144-1.846-1.183 0-2.143.826-2.143 1.846", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.997 11.429a.715.715 0 1 0 .005 1.428.715.715 0 0 0-.005-1.428Z", fill: "currentColor" }))); });

export { QnA };
//# sourceMappingURL=QnA.js.map
